module.exports = __webpack_public_path__ + "img/banner_logo@2x.756448f7.png";